export const employeesRoutes = [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('./views/Profile.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/receipts',
    name: 'receipts',
    component: () => import('./views/Receipts.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/vacations',
    name: 'Vacations',
    component: () => import('./views/Vacations.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/licenses',
    name: 'Licenses',
    component: () => import('./views/Licenses.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/documents&Policies',
    name: 'Documents & Policies',
    component: () => import('./views/Document&Policies.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
  {
    path: '/error-reports',
    name: 'error-reports',
    component: () => import('./views/ErrorReports.vue'),
    meta: {
      auth: true,
      layout: 'home',
      requiredRoles: ['employee', 'supervisor'],
    },
  },
]
